<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>申请信息
        </div>
        <div class="order-detail-box">
          <div class="label-val">
            <div class="label-1">申请时间</div>
            <div class="value-1">{{ detail.withdrawTime }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">货主姓名</div>
            <div class="value-1">{{ detail.username }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">联系电话</div>
            <div class="value-1">{{ detail.phone }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">提现金额</div>
            <div class="value-1 color52C41A">￥{{ detail.withdrawAmount }}</div>
          </div>
        </div>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>银行卡信息
        </div>
        <div class="order-detail-box">
          <div class="label-val">
            <div class="label-1">户名</div>
            <div class="value-1">{{ detail?.bankCard?.cardholder || "-" }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">开户行</div>
            <div class="value-1">{{ detail?.bankCard?.bankName || "-" }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">银行卡号</div>
            <div class="value-1">
              <custom-copy :txt="detail?.bankCard?.bankCardNo"></custom-copy>
            </div>
          </div>
        </div>
        <template v-if="!isDetail">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>开票处理
          </div>
          <el-row :gutter="20">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-col :span="24">
                <el-form-item label="提现结果：" prop="success">
                  <div class="radio-box">
                    <el-radio v-model="form.success" :label="true"
                      >成功</el-radio
                    >
                    <span>已完成银行转款，需上传付款凭证</span>
                  </div>
                  <div class="radio-box">
                    <el-radio v-model="form.success" :label="false"
                      >失败</el-radio
                    >
                    <span>未完成转款，需填写失败原因</span>
                  </div>
                </el-form-item>
              </el-col>

              <el-col :span="24" v-if="form.success">
                <el-form-item label="付款凭证：" prop="vouchers">
                  <upload-files2 v-model="form.vouchers"></upload-files2>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注：" prop="handleRemark">
                  <el-input
                    type="textarea"
                    clearable
                    rows="5"
                    placeholder="请输入备注"
                    v-model="form.handleRemark"
                    show-word-limit
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
        <template v-else>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>提现结果
          </div>
          <el-row class="common-info-box">
            <el-col :span="12">
              <span class="label">提现结果：</span>
              <span class="value">{{
                getLocalLabel("withdrawStatus", detail.status)
              }}</span>
            </el-col>
            <el-col :span="12">
              <span class="label">操作人：</span>
              <span class="value">{{ detail.handleUsername || "-" }}</span>
            </el-col>
            <el-col :span="24">
              <span class="label">操作时间：</span>
              <span class="value">{{ detail.handleTime || "-" }}</span>
            </el-col>
            <el-col :span="24">
              <span class="label">备注：</span>
              <span class="value">{{ detail.handleRemark || "-" }}</span>
            </el-col>
            <el-col
              :span="24"
              v-if="detail.vouchers && detail.vouchers.length > 0"
            >
              <span class="label">付款凭证：</span>
              <span class="value">
                <div class="common-image-box">
                  <el-image
                    v-for="(item, index) in detail.vouchers"
                    :key="index"
                    :src="getFileUrl(item.fileId)"
                    class="common-image"
                    :preview-src-list="[getFileUrl(item.fileId)]"
                  ></el-image>
                </div>
              </span>
            </el-col>
          </el-row>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { detailInfo, handleWithdraw } from "./api";
import UploadFiles2 from "@/components/UploadFiles4.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomCopy from "@/components/CustomCopy.vue";
import { getFileUrl } from "@/utils/tool";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "AddOrEdit",
  components: {
    CustomCopy,
    CustomTable,
    UploadFiles2,
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.detail = {};
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        handleRemark: "",
        success: true,
        vouchers: [],
        withdrawId: "",
      },
      detail: {},
      rules: {
        vouchers: [{ required: true, message: "处理凭证不能为空" }],
        success: [{ required: true, message: "处理凭证不能为空" }],
      },
      isDetail: false,
    };
  },
  mounted() {},
  methods: {
    getLocalLabel,
    getFileUrl,
    init(title, isDetail, row) {
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      this.form.withdrawId = row.withdrawId;
      if (this.isDetail) {
        this.dialogObj.confirmFn = "";
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      if (!!row) {
        this.getDetailInfo(row.withdrawId);
        // this.form = Object.assign({}, row);
      }
      this.dialogObj.show = true;
    },
    getDetailInfo(withdrawId) {
      detailInfo(withdrawId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            handleRemark: this.form.handleRemark,
            success: this.form.success,
            vouchers: this.form.vouchers,
            withdrawId: this.form.withdrawId,
          };
          handleWithdraw(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("处理成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .radio-box {
    display: flex;
    align-items: center;
    span {
      font-size: 0.12rem;
      color: #8c8c8c;
    }
  }
}
</style>
